import {OnInit, AfterViewInit, Component, Input} from '@angular/core';
import { Router } from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'store-rdsmodal-component',
    templateUrl: './rds-modal.component.html'
})
export class RdsModalComponent implements OnInit, AfterViewInit {

    @Input()
    public isExtensao = false;
    public isTimeout = false;
    public isLoading = true;
    public isMinhaFolha = false;
    public idForm: string;

    private readonly timeoutClock: any;
    private readonly loadingInterval: any;
    private readonly startedLoading: Date = new Date();

    constructor(public activeModal: NgbActiveModal, private router: Router) {

        /**
         * Bloqueadores de anúncios podem bloquear a requisição de criação do formulário (createForm) da RDS. Dessa forma, devido a dinâmica
         * da interação e por não ser possível identificar se o script foi carregado ou não (lógica está no script do cliente), é adicionado
         * um controle de timeout com mensagem 'genérica'. Foram efetuadas simulações diversas com throttle de internet.
         */

        this.loadingInterval = setInterval(() => {
            if (document.getElementsByClassName('rd-section').length > 0) {
                this.isLoading = false;
                clearInterval(this.loadingInterval);
                clearInterval(this.timeoutClock);
            }
        }, 100);

        this.timeoutClock = setInterval(() => {
            if (!this.isLoading) {
                clearInterval(this.timeoutClock);
            } else {
                /*
                * Se o script estiver rodando por mais de cinco segundos, irá mostrar a tela de aviso
                * Isso pode acontecer devido a demora, porém o mais provável que exista algo bloqueando requisições externas
                */
                if ((new Date().valueOf() - this.startedLoading.valueOf()) / 1000 > 5) {
                    this.isTimeout = true;
                    this.isLoading = false;
                    clearInterval(this.timeoutClock);
                    clearInterval(this.loadingInterval);
                }
            }
        }, 1000);
    }

    ngOnInit() {
        this.isMinhaFolha = this.router.url === '/produto/minha-folha';

        if (this.isExtensao) {
            this.idForm = 'solicitacao-de-demonstracao-extensoes-140b7dd805289ff5edc1'
        } else {
            this.idForm = 'solicitacao-de-demonstracao-paginas-de-produtos-10139906f2b4d74583df'
        }
    }

    ngAfterViewInit(): void {
        /*
        Conforme leitura da documentação e análise do código, não é possível saber quando o formulário foi criado.
        Dessa forma, foi adotada a estratégia de abrir, invocar a criação e quando criado habilitar.

        https://ajuda.rdstation.com.br/hc/pt-br/sections/115001143503-Integrar-formul%C3%A1rio-do-site
        */
        // @ts-ignore
        new window.RDStationForms(this.idForm, 'UA-534994-1').createForm();
    }

}
